import { apiCallCenter } from '@/plugins/axios'

export default {
  getDepartment(){
    return apiCallCenter().get('/relatorios/operadores/departamento/lazy')
  },

  getAgents() {
    return apiCallCenter().get('/relatorios/operadores/operadores/lazy')
  },
}
